class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  getCartComponent() {
    if (
      (document.body.dataset.cartType === 'drawer' || window.theme?.cartType === 'drawer') &&
      this.cartDrawer
    ) {
      return this.cartDrawer;
    }
    return this.cartNotification;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const cartComponent = this.getCartComponent();
    if (!cartComponent) return;

    cartComponent.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    if (submitButton.dataset.pickVariant === 'false') {
      document.querySelector('variant-selects').classList.add('notice');
      setTimeout(function () {
        document.querySelector('variant-selects').classList.remove('notice');
      }, 3000);
      return false;
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const sectionsToRequest = cartComponent.getSectionIdsToRequest
      ? cartComponent.getSectionIdsToRequest()
      : cartComponent.getSectionsToRender().map((section) => section.section || section.id);

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: sectionsToRequest,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        cartComponent.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
